
// 1. Facturas y Boletas
export const INVOICE_DOCUMENTATION: Record<string, string> = {
  "claveSecreta": "Clave única de la empresa generada en el Dashboard (Obligatorio).",
  "comprobante": "Objeto que contiene la información principal del documento (Obligatorio).",
  "tipoOperacion": "0101: Venta Interna, 0200: Exportación, 2001: Percepciones (Obligatorio).",
  "tipoDoc": "01: Factura, 03: Boleta (Obligatorio).",
  "serie": "Serie del documento. Ej: F001 para Facturas, B001 para Boletas (Obligatorio).",
  "correlativo": "Número correlativo del documento (Obligatorio).",
  "fechaEmision": "Fecha de emisión del documento (YYYY-MM-DD) (Obligatorio).",
  "horaEmision": "Hora de emisión del documento (HH:mm:ss) (Opcional).",
  "tipoMoneda": "Código de moneda ISO 4217 (Ej: PEN, USD) (Obligatorio).",
  "tipoPago": "Contado, Credito (Obligatorio).",
  "total": "Monto total del comprobante incluyendo impuestos (Obligatorio).",
  "mtoIGV": "Monto total del IGV (Obligatorio).",
  "mtoOperGravadas": "Base imponible de operaciones gravadas (Opcional si es gravada).",
  "mtoOperExoneradas": "Base imponible de operaciones exoneradas (Opcional).",
  "mtoOperInafectas": "Base imponible de operaciones inafectas (Opcional).",
  "totalTexto": "Representación del monto en letras (Obligatorio).",
  "cliente": "Información del receptor del comprobante (Obligatorio).",
  "numDoc": "RUC o DNI del cliente según tipoDoc (Obligatorio).",
  "rznSocial": "Nombre o Razón Social oficial del cliente (Obligatorio).",
  "items": "Colección de productos o servicios del comprobante (Obligatorio).",
  "codProducto": "Código interno o SKU del bien (Opcional).",
  "descripcion": "Descripción del producto o servicio (Obligatorio).",
  "unidad": "Unidad de medida (Ej: NIU para unidades, KGM para kilos) (Obligatorio).",
  "cantidad": "Cantidad del ítem (Obligatorio).",
  "mtoBaseIgv": "Base imponible para el cálculo del IGV por ítem.",
  "mtoValorUnitario": "Valor unitario del ítem sin considerar impuestos.",
  "mtoPrecioUnitario": "Precio de venta por unidad incluyendo impuestos (pago total).",
  "codeAfectAlt": "Código de afectación alternativo (Ej: 10 para Gravado).",
  "codeAfect": "Código de afectación al IGV (SUNAT). Ej: 1000 para IGV.",
  "nameAfect": "Nombre del tributo (Ej: IGV, EXO, INA).",
  "tipoAfect": "Código de tipo de tributo (Ej: VAT para IGV).",
  "igvPorcent": "Porcentaje de IGV aplicado (Ej: 18).",
  "igv": "Monto de IGV calculado para el ítem.",
  "igvOpi": "Impuesto a las operaciones internas del sistema."
};

// 2. Notas de Crédito y Débito
export const NOTE_DOCUMENTATION: Record<string, string> = {
  ...INVOICE_DOCUMENTATION,
  "tipoDoc": "07: Nota de Crédito, 08: Nota de Débito.",
  "codmotivo": "Código del motivo de emisión de la nota (SUNAT).",
  "descripcion": "Descripción detallada del motivo (Ej: ERROR DE EMISIÓN).",
  "serieRef": "Serie del comprobante que se está modificando.",
  "correlativoRef": "Correlativo del comprobante de referencia.",
  "tipoCompRef": "01: Factura, 03: Boleta (Tipo de documento de referencia)."
};

// 3. Guías de Remisión
export const GUIA_DOCUMENTATION: Record<string, string> = {
  "claveSecreta": "Clave única de la empresa generada en el Dashboard.",
  "tipoDoc": "09: Guía Remitente, 31: Guía Transportista.",
  "serie": "Serie del documento (Ej: T001 para Guías).",
  "correlativo": "Número correlativo del documento.",
  "fechaEmision": "Fecha de emisión de la guía (YYYY-MM-DD).",
  "fechaTraslado": "Fecha de inicio del traslado de los bienes (YYYY-MM-DD).",
  "motivoTraslado": "01: Venta, 02: Compra, 04: Traslado entre establecimientos, 08: Importación, 09: Exportación.",
  "modalidadTraslado": "01: Transporte Público, 02: Transporte Privado.",
  "pesoTotal": "Peso bruto total de la carga (incluye embalaje).",
  "unidadMedida": "Unidad de medida del peso (KGM: Kilogramos, TNE: Toneladas).",
  "ubigeoPartida": "Código UBIGEO del punto donde se inicia el traslado.",
  "direccionPartida": "Dirección detallada del punto de partida.",
  "ubigeoLlegada": "Código UBIGEO del punto de destino final.",
  "direccionLlegada": "Dirección detallada del punto de llegada.",
  "destinatario": "Objeto con información de la entidad que recibirá los bienes.",
  "transportista": "Objeto con información de la empresa de transporte (Obligatorio en Modalidad 01).",
  "items": "Lista de bienes o mercancías que se están trasladando.",
  "codProducto": "Código interno del bien.",
  "descripcion": "Descripción detallada del bien.",
  "unidad": "Unidad de medida del bien (Ej: NIU, KGM).",
  "cantidad": "Cantidad total de unidades del ítem."
};

// 4. Comunicación de Bajas (Voided)
export const VOIDED_DOCUMENTATION: Record<string, string> = {
  "claveSecreta": "Clave única de la empresa generada en el Dashboard.",
  "cabecera": "Objeto contenedor de los datos del envío de baja.",
  "tipodoc": "RA: Comunicación de Bajas (Facturas), RC: Resumen Diario (Boletas).",
  "serie": "Serie del documento (AAAAMMDD para Bajas, Correlativo Normal para otros).",
  "correlativo": "Número correlativo del día para transacciones del mismo tipo.",
  "fechaEmision": "Fecha de generación del archivo (YYYY-MM-DD).",
  "fechaEnvio": "Fecha en la que se envía la comunicación (YYYY-MM-DD).",
  "items": "Lista de documentos que se desean anular.",
  "motivo": "Explicación breve de por qué se anula el documento.",
  "ticket": "Código devuelto por SUNAT para consultar el estado del proceso."
};

// 5. Resumen Diario (Summary)
export const SUMMARY_DOCUMENTATION: Record<string, string> = {
  ...VOIDED_DOCUMENTATION,
  "moneda": "Código ISO de la moneda (Ej: PEN).",
  "importe_total": "Monto total cobrado en la boleta/nota.",
  "op_gravadas": "Suma de bases imponibles gravadas.",
  "igv_total": "Suma total de IGV del documento.",
  "numdoc": "DNI o RUC del cliente (00000000 si es menor a S/ 700 y no se identifica)."
};

// 6. Envío General (Send)
export const SEND_DOCUMENTATION: Record<string, string> = {
  "claveSecreta": "Clave única de la empresa generada en el Dashboard.",
  "comprobante": "Objeto con la identificación mínima para el envío (tipoDoc, serie, correlativo).",
  "tipoDoc": "01: Factura, 03: Boleta, 07: Notas, 08: Notas, 09: Guía Remitente, 31: Guía Transportista.",
  "serie": "Serie del documento a enviar (Ej: F001, T001).",
  "correlativo": "Número correlativo del documento a enviar."
};

// 7. Tokens y Status
export const STATUS_DOCUMENTATION: Record<string, string> = {
  "claveSecreta": "Clave única de la empresa generada en el Dashboard.",
  "nombreDoc": "Nombre completo del archivo XML enviado (Ej: RUC-01-F001-1).",
  "ticket": "Número de ticket devuelto por SUNAT en el envío previo."
};

export const ALL_DOCUMENTATION: Record<string, Record<string, string>> = {
  "invoice": INVOICE_DOCUMENTATION,
  "nota-credito": NOTE_DOCUMENTATION,
  "nota-debito": NOTE_DOCUMENTATION,
  "guia": GUIA_DOCUMENTATION,
  "bajas": VOIDED_DOCUMENTATION,
  "resumen": SUMMARY_DOCUMENTATION,
  "enviar": SEND_DOCUMENTATION,
  "status": STATUS_DOCUMENTATION
};

export const INVOICE_PRESETS: Record<string, any> = {
  gravada: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101",
      "tipoDoc": "01",
      "serie": "F001",
      "correlativo": "1",
      "observacion": "",
      "fechaEmision": "2023-02-14",
      "horaEmision": "17:00:00",
      "tipoMoneda": "PEN",
      "tipoPago": "Contado",
      "total": 118,
      "mtoIGV": 18,
      "igvOp": 0,
      "mtoOperGravadas": 100,
      "totalTexto": "SON CIENTO DIECIOCHO CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [{
      "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "tipoPrecio": "01", "cantidad": 1,
      "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfectAlt": 10,
      "codeAfect": 1000, "nameAfect": "IGV", "tipoAfect": "VAT", "igvPorcent": 18, "igv": 18, "igvOpi": 18
    }]
  },
  gratuita: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "2",
      "fechaEmision": "2023-02-14", "horaEmision": "17:00:00", "tipoMoneda": "PEN", "tipoPago": "Contado",
      "total": 0, "mtoIGV": 0, "igvOp": 10.8, "mtoOperGratuitas": 60, "totalTexto": "SON SESENTA CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [{
      "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "tipoPrecio": "02", "cantidad": 2,
      "mtoBaseIgv": 60, "mtoValorUnitario": 0, "mtoPrecioUnitario": 30, "codeAfectAlt": 11,
      "codeAfect": 9996, "nameAfect": "GRA", "tipoAfect": "FRE", "igvPorcent": 18, "igv": 10.8, "igvOpi": 10.8
    }]
  },
  inafecta: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "3",
      "fechaEmision": "2023-02-14", "horaEmision": "17:00:00", "tipoMoneda": "PEN", "tipoPago": "Contado",
      "total": 100, "mtoIGV": 0, "igvOp": 0, "mtoOperInafectas": 100, "totalTexto": "SON CIEN CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [{
      "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "tipoPrecio": "01", "cantidad": 2,
      "mtoBaseIgv": 100, "mtoValorUnitario": 50, "mtoPrecioUnitario": 50, "codeAfectAlt": 30,
      "codeAfect": 9998, "nameAfect": "INA", "tipoAfect": "FRE", "igvPorcent": 0, "igv": 0, "igvOpi": 0
    }]
  },
  exonerada: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "4",
      "fechaEmision": "2023-02-14", "horaEmision": "17:00:00", "tipoMoneda": "PEN", "tipoPago": "Contado",
      "total": 100, "mtoIGV": 0, "igvOp": 0, "mtoOperExoneradas": 100, "totalTexto": "SON CIEN CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [{
      "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "tipoPrecio": "01", "cantidad": 2,
      "mtoBaseIgv": 100, "mtoValorUnitario": 50, "mtoPrecioUnitario": 50, "codeAfectAlt": 20,
      "codeAfect": 9997, "nameAfect": "EXO", "tipoAfect": "VAT", "igvPorcent": 0, "igv": 0, "igvOpi": 0
    }]
  },
  icbper: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "5",
      "fechaEmision": "2023-02-14", "horaEmision": "17:00:00", "tipoMoneda": "PEN", "tipoPago": "Contado",
      "total": 118.5, "mtoIGV": 18, "igvOp": 0, "icbper": 0.5, "mtoOperGravadas": 100, "totalTexto": "SON CIENTO DIECIOCHO CON 50/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [{
      "codProducto": "BL001", "descripcion": "BOLSA DE PLÁSTICO", "unidad": "NIU", "tipoPrecio": "01", "cantidad": 1,
      "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfectAlt": 10,
      "codeAfect": 1000, "nameAfect": "IGV", "tipoAfect": "VAT", "igvPorcent": 18, "igv": 18, "igvOpi": 18, "icbper": 0.50
    }]
  },
  combinada: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "6",
      "total": 318, "mtoIGV": 18, "igvOp": 10.8, "mtoOperGravadas": 100, "mtoOperExoneradas": 100, "mtoOperInafectas": 100, "mtoOperGratuitas": 60,
      "totalTexto": "SON TRECIENTOS DIESIOCHO CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [
      { "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "tipoPrecio": "01", "cantidad": 1, "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfectAlt": 10, "codeAfect": 1000, "nameAfect": "IGV", "tipoAfect": "VAT", "igvPorcent": 18, "igv": 18, "igvOpi": 18 },
      { "codProducto": "PR002", "descripcion": "PRODUCTO 2", "unidad": "NIU", "tipoPrecio": "02", "cantidad": 2, "mtoBaseIgv": 60, "mtoValorUnitario": 0, "mtoPrecioUnitario": 30, "codeAfectAlt": 11, "codeAfect": 9996, "nameAfect": "GRA", "tipoAfect": "FRE", "igvPorcent": 18, "igv": 10.8, "igvOpi": 10.8 }
    ]
  },
  combinadaIcbper: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "7",
      "total": 318.5, "mtoIGV": 18, "igvOp": 10.8, "icbper": 0.5, "mtoOperGravadas": 100, "mtoOperExoneradas": 100, "mtoOperInafectas": 100, "mtoOperGratuitas": 60,
      "totalTexto": "SON TRECIENTOS DIESIOCHO CON 50/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [
      { "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "tipoPrecio": "01", "cantidad": 1, "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfectAlt": 10, "codeAfect": 1000, "nameAfect": "IGV", "icbper": 0.5 },
      { "codProducto": "PR002", "descripcion": "PRODUCTO 2", "unidad": "NIU", "tipoPrecio": "02", "cantidad": 2, "mtoBaseIgv": 60, "mtoValorUnitario": 0, "mtoPrecioUnitario": 30, "codeAfectAlt": 11, "codeAfect": 9996, "nameAfect": "GRA" }
    ]
  },
  dsctoGlobal: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "8",
      "total": 114.46, "dsctoGlobal": { "descuento": 3, "codigoTipo": "02", "descuentoFactor": "1", "montoBase": "3" },
      "mtoIGV": 17.46, "mtoOperGravadas": 97, "totalTexto": "SON CIENTO CATORCE CON 46/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "tipoPrecio": "01", "cantidad": 1, "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfectAlt": 10, "codeAfect": 1000 }]
  },
  dsctoPorLinea: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "9",
      "total": 114.46, "mtoIGV": 17.46, "mtoOperGravadas": 97, "totalTexto": "SON CIENTO CATORCE CON 46/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO", "direccion": "----" },
    "items": [{
      "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "cantidad": 1, "mtoBaseIgv": 97, "mtoValorUnitario": 100, "mtoPrecioUnitario": 114.46, "codeAfectAlt": 10, "codeAfect": 1000,
      "descuentos": { "monto": 3, "codigoTipo": "00", "factor": "1", "montoBase": "3" }
    }]
  },
  credito: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "10",
      "tipoPago": "Credito", "cuotas": [{ "cuota": "59", "fechaCuota": "2023-02-21" }, { "cuota": "59", "fechaCuota": "2023-02-24" }],
      "total": 118, "mtoIGV": 18, "mtoOperGravadas": 100, "totalTexto": "SON CIENTO DIECIOCHO CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "cantidad": 1, "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfectAlt": 10, "codeAfect": 1000 }]
  },
  bienesSelva: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "11",
      "total": 100, "mtoIGV": 0, "mtoOperExoneradas": 100, "bienesSelva": "si", "totalTexto": "SON CIEN CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "cantidad": 1, "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 100, "codeAfectAlt": 20, "codeAfect": 9997 }]
  },
  serviciosSelva: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "12",
      "total": 100, "mtoIGV": 0, "mtoOperExoneradas": 100, "serviciosSelva": "si", "totalTexto": "SON CIEN CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "unidad": "NIU", "cantidad": 1, "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 100, "codeAfectAlt": 20, "codeAfect": 9997 }]
  },
  gravadaPercepcion: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "2001", "tipoDoc": "01", "serie": "F001", "correlativo": "13",
      "total": 118, "mtoIGV": 18, "mtoOperGravadas": 100, "percepcion": { "codigo": "51", "porcentaje": 0.02, "base": 20, "monto": 0.04, "total": 20.4 }
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfectAlt": 10, "codeAfect": 1000 }]
  },
  gravadaRetencion: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "F001", "correlativo": "14",
      "total": 118, "mtoIGV": 18, "mtoOperGravadas": 100, "retencion": { "codigo": "62", "porcentaje": 0.03, "base": 20, "monto": 0.6 }
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfect": 1000 }]
  },
  exportacion: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0200", "tipoDoc": "01", "serie": "F001", "correlativo": "15",
      "total": 100, "mtoExportacion": 100, "totalTexto": "SON CIEN CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "0", "numDoc": "11111111111", "rznSocial": "CLIENTE EXTRANJERO" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "cantidad": 1, "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 100, "codeAfect": 9995 }]
  },
  contingencia: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101", "tipoDoc": "01", "serie": "0001", "correlativo": "1",
      "total": 118, "mtoIGV": 18, "mtoOperGravadas": 100, "totalTexto": "SON CIENTO DIECIOCHO CON 00/100 SOLES"
    },
    "cliente": { "codigoPais": "PE", "tipoDoc": "6", "numDoc": "11111111111", "rznSocial": "EMPRESA DEMO" },
    "items": [{ "codProducto": "PR001", "descripcion": "PRODUCTO 1", "mtoBaseIgv": 100, "mtoValorUnitario": 100, "mtoPrecioUnitario": 118, "codeAfect": 1000 }]
  }
};

export const GUIAS_PRESETS: Record<string, any> = {
  remitentePublico: {
    "claveSecreta": "TU_CLAVE",
    "comprobante": {
      "tipoDoc": "09", "serie": "T001", "correlativo": "1",
      "fechaEmision": "2023-02-14", "fechaTraslado": "2023-02-15",
      "motivoTraslado": "01", "modalidadTraslado": "01",
      "pesoTotal": 50.5, "unidadMedida": "KGM",
      "ubigeoPartida": "150101", "direccionPartida": "AV. LIMA 123",
      "ubigeoLlegada": "150102", "direccionLlegada": "AV. CALLAO 456"
    },
    "destinatario": {
      "tipoDoc": "6", "numDoc": "20100010001", "rznSocial": "CLIENTE DESTINO SAC"
    },
    "transportista": {
      "tipoDoc": "6", "numDoc": "20500050005", "rznSocial": "TRANSPORTES RAPIDOS SA"
    },
    "items": [
      { "codProducto": "PRD01", "descripcion": "CAJAS DE REPUESTOS", "unidad": "NIU", "cantidad": 10 }
    ]
  },
  transportista: {
    "claveSecreta": "TU_CLAVE",
    "comprobante": {
      "tipoDoc": "31", "serie": "V001", "correlativo": "1",
      "fechaEmision": "2023-02-14", "fechaTraslado": "2023-02-15",
      "motivoTraslado": "01", "modalidadTraslado": "02",
      "pesoTotal": 100, "unidadMedida": "KGM",
      "ubigeoPartida": "150101", "direccionPartida": "ALMACEN CENTRAL",
      "ubigeoLlegada": "150105", "direccionLlegada": "TIENDA SURCO"
    },
    "items": [
      { "codProducto": "CRT20", "descripcion": "CARGA GENERAL", "unidad": "NIU", "cantidad": 1 }
    ]
  }
};

export const GRAVADA_VARIANTS: Record<string, any> = {
  general: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101",
      "tipoDoc": "01",
      "serie": "F001",
      "correlativo": "1",
      "fechaEmision": "2026-02-07",
      "horaEmision": "08:00:00",
      "tipoMoneda": "PEN",
      "tipoPago": "Contado",
      "observacion": "Venta al contado con descuento"
    },
    "cliente": {
      "codigoPais": "PE",
      "tipoDoc": "6",
      "numDoc": "20611654571",
      "rznSocial": "EMPRESA DEMO S.A.C.",
      "direccion": "AV. PRINCIPAL 123, LIMA"
    },
    "items": [
      {
        "codProducto": "PROD001",
        "descripcion": "Laptop HP Pavilion 15",
        "unidad": "NIU",
        "cantidad": 2,
        "mtoBaseIgv": 4000.00,
        "mtoValorUnitario": 2000.00,
        "mtoPrecioUnitario": 2360.00,
        "codeAfect": "10",
        "igvPorcent": 18.00,
        "igv": 720.00
      },
      {
        "codProducto": "PROD002",
        "descripcion": "Mouse Logitech MX Master 3",
        "unidad": "NIU",
        "cantidad": 3,
        "mtoBaseIgv": 450.00,
        "mtoValorUnitario": 150.00,
        "mtoPrecioUnitario": 177.00,
        "codeAfect": "10",
        "igvPorcent": 18.00,
        "igv": 81.00
      }
    ],
    "descuentos": [
      {
        "motivoCodigo": "02",
        "factor": 0.05,
        "monto": 222.50,
        "base": 4450.00
      }
    ]
  },
  restaurante: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
        "tipoOperacion": "0101",
        "tipoDoc": "01",
        "serie": "F003",
        "correlativo": "1",
        "fechaEmision": "2026-03-05",
        "horaEmision": "13:15:00",
        "tipoMoneda": "PEN",
        "tipoPago": "Contado",
        "observacion": "Ley 32387 - Tasa 10.5% (Restaurantes 2026)"
    },
    "cliente": {
        "codigoPais": "PE",
        "tipoDoc": "6",
        "numDoc": "10730426548",
        "rznSocial": "Renzo Antonio Arroyo Andrade",
        "direccion": "Abraham Valdelomar 665"
    },
    "items": [
        {
            "codProducto": "REST001",
            "descripcion": "Almuerzo Ejecutivo (10.5%)",
            "unidad": "NIU",
            "cantidad": 1,
            "mtoBaseIgv": 12.00,
            "mtoValorUnitario": 12.00,
            "mtoPrecioUnitario": 13.26,
            "codeAfect": "10",
            "igvPorcent": 10.50,
            "igv": 1.26
        }
    ],
    "descuentos": [
        {
            "motivoCodigo": "02",
            "factor": 0.10,
            "monto": 1.20,
            "base": 12.00
        }
    ]
  },
  descuento_obs: {
    "claveSecreta": "tu-clave-secreta-aqui",
    "comprobante": {
      "tipoOperacion": "0101",
      "tipoDoc": "01",
      "serie": "F003",
      "correlativo": "2",
      "fechaEmision": "2026-01-28",
      "horaEmision": "10:40:00",
      "tipoMoneda": "PEN",
      "tipoPago": "Contado",
      "observacion": "IGV 8% + IPM 2% - Ley 31556"
    },
    "cliente": {
      "codigoPais": "PE",
      "tipoDoc": "6",
      "numDoc": "10730426548",
      "rznSocial": "Renzo Antonio Arroyo Andrade",
      "direccion": "Abraham Valdelomar 665"
    },
    "items": [
      {
        "codProducto": "REST002",
        "descripcion": "Cena Especial (8% + 2%)",
        "unidad": "NIU",
        "cantidad": 1,
        "mtoBaseIgv": 20.00,
        "mtoValorUnitario": 20.00,
        "mtoPrecioUnitario": 22.00,
        "codeAfect": "10",
        "impuestos": [
          {
            "codigo": "1000",
            "nombre": "IGV",
            "tipo": "VAT",
            "porcentaje": 8.00,
            "monto": 1.60
          },
          {
            "codigo": "1016",
            "nombre": "IPM",
            "tipo": "VAT",
            "porcentaje": 2.00,
            "monto": 0.40
          }
        ]
      }
    ],
    "descuentos": [
      {
        "motivoCodigo": "02",
        "factor": 0.05,
        "monto": 1.00,
        "base": 20.00
      }
    ]
  }
};
